module.exports = __webpack_public_path__ + "static/img/app-slide-show3.7954efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/app-slide-show3.png
// module id = lrc4
// module chunks = 44